/* eslint-disable no-undef */
import extend from './extend';

var headerScrollState = {
  height: 0,
  ticking: false,
};

function measureDesktopHeaderHeight() {
  var header = document.querySelector('.g_header');
  if (!header || window.innerWidth < 481) return 0;

  var clone = header.cloneNode(true);
  clone.classList.remove('scrolled');
  clone.style.position = 'absolute';
  clone.style.top = '0';
  clone.style.left = '-9999px';
  clone.style.visibility = 'hidden';
  clone.style.pointerEvents = 'none';
  clone.style.height = 'auto';
  clone.style.transition = 'none';
  clone.style.animation = 'none';
  document.body.appendChild(clone);
  var height = clone.getBoundingClientRect().height;
  clone.parentNode.removeChild(clone);
  return height;
}

function updateHeaderFlowHeight() {
  headerScrollState.height = measureDesktopHeaderHeight();
  if (headerScrollState.height > 0) {
    document.documentElement.style.setProperty(
      '--header-flow-height',
      headerScrollState.height + 'px'
    );
  } else {
    document.documentElement.style.removeProperty('--header-flow-height');
  }
}

function updateScrolledHeaderState() {
  var $header = $('.g_header');
  if (!$header.length) {
    headerScrollState.ticking = false;
    return;
  }

  var viewHeight = $(window).innerHeight();
  var contentsHeight = $('body').get(0).scrollHeight;
  var headerHeight = headerScrollState.height || $header.outerHeight();
  var scrollHeight = contentsHeight - viewHeight;
  var scrollTop = $(window).scrollTop();
  var isCompact = false;
  if ($(window).width() < 768) {
    isCompact = scrollTop > 0;
  } else if (scrollHeight > headerHeight * 2) {
    isCompact = scrollTop > headerHeight - 10;
  }
  $header.toggleClass('scrolled', isCompact);
  headerScrollState.ticking = false;
}

function requestScrolledHeaderUpdate() {
  if (headerScrollState.ticking) return;
  headerScrollState.ticking = true;
  window.requestAnimationFrame(updateScrolledHeaderState);
}

export default function common() {
  $(function () {
    extend();

    var num = 10;
    var num_sp = 10;

    //pagetop
    var flag = false;
    var pagetop = $('.pagetop');
    $(window).scroll(function () {
      var windowWidth = $(window).width();
      if (windowWidth < 768) {
        if ($(this).scrollTop() > num_sp) {
          if (flag == false) {
            flag = true;
            pagetop.stop().animate(
              {
                bottom: '140px',
              },
              200
            );
          }
        } else {
          if (flag) {
            flag = false;
            pagetop.stop().animate(
              {
                bottom: '-250px',
              },
              200
            );
          }
        }
      } else {
        if ($(this).scrollTop() > num) {
          if (flag == false) {
            flag = true;
            pagetop.stop().animate(
              {
                bottom: '78px',
              },
              200
            );
          }
        } else {
          if (flag) {
            flag = false;
            pagetop.stop().animate(
              {
                bottom: '-250px',
              },
              200
            );
          }
        }
      }
    });
    pagetop.click(function () {
      $('body, html').animate({ scrollTop: 0 }, 100);
      return false;
    });

    $('.datePick').datepicker({
      dateFormat: 'yy/mm/dd',
      //クリアボタン追加
      onSelect: function () {
        let value = $(this).val();
        let e = new Event('input', {
          bubbles: true,
          cancelable: true,
        });
        e.value = value;
        this.dispatchEvent(e);
        if (value == null || value == '') {
          $(this).next('.dateClear').remove();
          $(this).unwrap();
        } else {
          //日付選択重複の場合があるので
          if ($(this).parents('.wrapDate').length) {
            $(this).next('.dateClear').remove();
            $(this).unwrap();
          }
          $(this)
            .wrap("<div class='wrapDate'></div>")
            .after('<span class="dateClear"></span>');
        }
      },
    });

    $(document).on('click', '.dateClear', function () {
      var targetDate = $(this).prev('.datePick');
      $.datepicker._clearDate(targetDate);
    });

    let changeDate = (obj) => {
      let value = $(obj).val();
      let e = new Event('input', {
        bubbles: true,
        cancelable: true,
      });
      e.value = value;
      obj.dispatchEvent(e);
      if (value == null || value == '') {
        $(obj).next('.dateTimeClear').remove();
        $(obj).unwrap();
      } else if ($(obj).parents('.wrapDate').length) {
        $(obj).next('.dateTimeClear').remove();
        $(obj).unwrap();
        $(obj)
          .wrap("<div class='wrapDate'></div>")
          .after('<span class="dateTimeClear"></span>');
      } else {
        $(obj)
          .wrap("<div class='wrapDate'></div>")
          .after('<span class="dateTimeClear"></span>');
      }
    };
    $('.dateTimePick').datetimepicker({
      timeInput: true,
      timeFormat: 'HH:mm',
      closeText: '閉じる',
      currentText: '現在日時を設定',
      timeText: '時間',
      hourText: '時',
      minuteText: '分',
      onSelect: function () {
        changeDate(this);
      },
      afterInject: function () {
        $(`#${this.$input[0].id}`).change(function () {
          changeDate(this);
        });
      },
    });

    $(document).on('click', '.dateTimeClear', function () {
      var targetDate = $(this).prev('.dateTimePick');
      $.datepicker._clearDate(targetDate);
    });

    updateHeaderFlowHeight();
    updateScrolledHeaderState();

    $(window)
      .off('.commonHeader')
      .on('load.commonHeader resize.commonHeader', function () {
        updateHeaderFlowHeight();
        updateScrolledHeaderState();
      })
      .on('scroll.commonHeader', function () {
        requestScrolledHeaderUpdate();
      });
  });
}
